export function calcRentPerMonth(
  startDate: string,
  endDate: string,
  sep: string,
  rentAmount: number,
  dateFunc: Function,
  remainRentFunc: Function,
  remainDaysFunc: Function
) {
  const { dateAttr } = dateFunc(startDate, endDate, remainDaysFunc, sep);
  const RENTPERMONTH = [];
  let remainingAmount = 0;
  const dateRangeArray = dateAttr.middleRangeDates;
  const daysRemains = dateAttr.remainingDays;

  if (dateAttr.MONTHRANGE === 0 && dateAttr.isSameYear) {
    return [
      {
        startDate: dateAttr.startDateObj,
        endDate: dateAttr.endDateObj,
        rent: rentAmount,
      },
    ];
  }

  if (daysRemains <= 30) {
    remainingAmount = remainRentFunc(rentAmount, 30, daysRemains);
  }

  for (const date of dateRangeArray) {
    const lastDateIndex = dateRangeArray.indexOf(date) + 1;
    const isLastIndexExists = Boolean(dateRangeArray[lastDateIndex]);
    if (
      lastDateIndex === dateRangeArray.length - 1 &&
      dateAttr.areDatesNotEqual
    ) {
      rentAmount = remainingAmount;
    }
    if (isLastIndexExists) {
      RENTPERMONTH.push({
        startDate: date,
        endDate: dateRangeArray[lastDateIndex],
        rent: rentAmount,
      });
    }
  }

  if (dateAttr.areDatesNotEqual) {
    const lastAmount = RENTPERMONTH.pop();
    RENTPERMONTH.push({ ...lastAmount, rent: remainingAmount });
  }

  return RENTPERMONTH;
}

export function calcDateRange(
  startDate: string,
  endDate: string,
  remainFunc: Function,
  sep: string = '-'
) {
  const [SYEAR, SMONTH, SDATE] = startDate.split(sep);
  const [EYEAR, EMONTH, EDATE] = endDate.split(sep);
  const MONTHRANGE = Number(EMONTH) - Number(SMONTH);
  const isSameYear = Number(SYEAR) === Number(EYEAR);
  const areDatesNotEqual = Number(SDATE) !== Number(EDATE);

  const startDateObj = new Date(
    Number(SYEAR),
    Number(SMONTH) - 1,
    Number(SDATE)
  );
  const endDateObj = new Date(Number(EYEAR), Number(EMONTH) - 1, Number(EDATE));
  const middleRangeDates = [startDateObj];
  const startDateObjClone = new Date(startDateObj);
  let remainingDays = 0;

  while (startDateObjClone <= endDateObj) {
    const newDateObj = new Date(
      startDateObjClone.setMonth(startDateObjClone.getMonth() + 1)
    );
    if (newDateObj <= endDateObj) {
      middleRangeDates.push(newDateObj);
    }
  }

  if (areDatesNotEqual) {
    remainingDays = remainFunc(
      middleRangeDates[middleRangeDates.length - 1],
      endDateObj
    );
    middleRangeDates.push(endDateObj);
  }

  return {
    dateAttr: {
      startDateObj,
      endDateObj,
      MONTHRANGE,
      remainingDays,
      isSameYear,
      areDatesNotEqual,
      middleRangeDates,
    },
  };
}

export function calcRemainingRent(
  rentAmount: number,
  baseDays: number,
  remainingDays: number
) {
  return (rentAmount / baseDays) * remainingDays;
}

export function calcRemainingDays(startDate: Date, endDate: Date) {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const remainingDays = Math.round(
    Math.abs((startDate.getTime() - endDate.getTime()) / oneDay)
  );

  return remainingDays;
}

export function getDateRepr(date: any) {
  const months = {
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'Jun',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
  };

  const getShortMonth = date.slice(4, 7).trim();
  const getFullYear = date.slice(10).trim();
  const getOnlyDate = date.slice(3).trim();
  return {
    month: months[getShortMonth],
    year: getFullYear,
    date: getOnlyDate,
  };
}

export function getPrevDate(date: string, daysPrior: number) {
  const prevDate = new Date(date);
  prevDate.setDate(prevDate.getDate() - daysPrior);
  return prevDate.toDateString();
}

export const getPrevMonthAndYear = (date: string, monthsPrior: number) => {
  const newDate = new Date(date);
  return {
    month: new Date(
      newDate.setMonth(newDate.getMonth() - monthsPrior)
    ).getMonth(),
    year: new Date(
      newDate.setMonth(newDate.getMonth() - monthsPrior)
    ).getFullYear(),
  };
};



// WEBPACK FOOTER //
// ./utils/rentUtils.ts